import { InputField } from "@typings/InputField";

export type ChangePasswordInput = {
  password: string;
  confPassword: string;
};

class InputFields {
  FIELDS: InputField[] = [
    {
      name: "password",
      type: "string",
      label: "New Password",
      required: true,
      password: true,
      validate: (field: InputField) =>
        Boolean(field.value) || "Password is too weak",
    },
    {
      name: "confPassword",
      type: "string",
      label: "Confirm Password",
      required: true,
      password: true,
      validate: (field: InputField, otherFields: InputField[]) =>
        otherFields.find(f => f.name === "password")?.value === field.value ||
        "Passwords do not match",
    },
  ];

  buildData(fields: InputField[]): ChangePasswordInput {
    const getValue = (name: keyof ChangePasswordInput): any =>
      fields.find(f => f.name === name)?.value;

    return {
      password: getValue("password"),
      confPassword: getValue("confPassword"),
    };
  }
}

export default new InputFields();
